import { NewRelicManager } from './NewRelicManager'
import { TENANT } from 'constants.app'
export const newRelic = NewRelicManager.getInstance(TENANT)
